import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/book/book';
import 'Bem/journal/sn-share/sn-share';
import 'Bem/journal/articles/articles';
import 'Bem/journal/test-offer/test-offer';
import 'Bem/site/mail-form/mail-form';
import { Reactions } from 'Lib/reactions/reactions';

const reactions = new Reactions(document.querySelectorAll('.reactions'));

reactions.init();

svgSpriteLoader('/journal/test-offer/svg/sprite.svg?v=20180320');